import { ToastContainer } from "react-toastify";
import Loader from "./components/Loader";
import Router from "./routing/Router";
import "react-toastify/dist/ReactToastify.css";
import ReactGA from "react-ga4";

function App() {
  const gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID;

  if (gaTrackingId) {
    ReactGA.initialize(gaTrackingId);
  }
  return (
    <>
      <Router />
      <Loader />
      <ToastContainer />
    </>
  );
}

export default App;
